var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef


//////////////////
// WEBPACK FOOTER
// /~/babel-polyfill/~/core-js/modules/_core.js
// module id = 100
// module chunks = 0